<div class="page-wrapper">
    <div class="page-header list-page-header mb-3 align-items-end">

        <div class="d-flex align-items-center gap-3">
            <h4 class="page-title ">COLLECTIONS</h4>
        </div>


        <div class="summary-wrapper" *ngIf="data">
            <div class="count item">
                <span class="title">Total Transaction: </span>
                <span class="value">
                    @if(data?.totalCount || data?.totalCount == 0){
                    {{ data?.totalCount | number }}
                    } @else {
                    <span class="spinner-light"></span>
                    }
                </span>
            </div>

            <div class="transaction-value item">
                <span class="title">Total Value: </span>
                <span class="value">
                    @if(data?.totalAmount || data?.totalAmount == 0){
                    {{ data?.totalAmount | number }}
                    } @else {
                    <span class="spinner-light"></span>
                    }
                </span>
            </div>
        </div>

        <div class="tab-actions py-1">
            <div class="d-flex gap-2 align-items-center flex-wrap">

                <div class="amc-table-action-wrapper">


                    <button *ngIf="data" class="custom-btn-primary" data-bs-toggle="dropdown"
                        (click)="attemptExport($event)">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10.3741 13.9445L12.568 11.7506V13.5528H13.3516V10.4186H10.2174V11.2021H12.0196L9.82562 13.3961L10.3741 13.9445ZM1.59835 14.3363C1.1674 14.3363 0.798346 14.1827 0.491195 13.8756C0.184043 13.5684 0.030729 13.1996 0.0312513 12.7692V1.79952C0.0312513 1.36857 0.184827 0.999518 0.491979 0.692367C0.79913 0.385215 1.16792 0.231901 1.59835 0.232423H12.568C12.999 0.232423 13.3681 0.385999 13.6752 0.69315C13.9824 1.0003 14.1357 1.36909 14.1351 1.79952V7.04931C13.887 6.93177 13.6324 6.83044 13.3712 6.74529C13.11 6.66014 12.8423 6.59824 12.568 6.55959V1.79952H1.59835V12.7692H6.33883C6.37801 13.0565 6.44017 13.3308 6.52531 13.5919C6.61046 13.8531 6.71154 14.1013 6.82855 14.3363H1.59835ZM1.59835 11.9857V12.7692V1.79952V6.55959V6.50082V11.9857ZM3.16545 11.2021H6.35842C6.39759 10.9279 6.45975 10.6602 6.5449 10.399C6.63005 10.1378 6.7246 9.88315 6.82855 9.63502H3.16545V11.2021ZM3.16545 8.06792H7.9451C8.363 7.67615 8.82973 7.34967 9.34531 7.08848C9.86088 6.8273 10.4128 6.651 11.0009 6.55959V6.50082H3.16545V8.06792ZM3.16545 4.93372H11.0009V3.36662H3.16545V4.93372ZM11.7845 15.9034C10.7006 15.9034 9.77652 15.5213 9.0123 14.7571C8.24808 13.9929 7.86623 13.0691 7.86675 11.9857C7.86675 10.9018 8.24886 9.97769 9.01308 9.21347C9.77731 8.44925 10.7011 8.0674 11.7845 8.06792C12.8684 8.06792 13.7925 8.45003 14.5567 9.21425C15.3209 9.97848 15.7028 10.9023 15.7022 11.9857C15.7022 13.0696 15.3201 13.9936 14.5559 14.7579C13.7917 15.5221 12.8679 15.9039 11.7845 15.9034Z"
                                fill="white" />
                        </svg>


                        Export Data
                    </button>

                    <div class="dropdown-menu amc-table-action-select" [class.show]="dropdownOpen">
                        <div class="dropdown-wrapper">
                            <div class="action-btn" role="button" (click)="exportExcel(); $event.stopPropagation()">
                                Excel
                                <div class="spinner-light" *ngIf="isExportingExcel"></div>
                            </div>
                            <div class="action-btn" role="button" (click)="exportPdf(); $event.stopPropagation()">
                                PDF
                                <div class="spinner-light" *ngIf="isExportingPdf"></div>

                            </div>
                            <div class="action-btn" role="button" (click)="exportCsv(); $event.stopPropagation()">
                                CSV
                                <div class="spinner-light" *ngIf="isExportingCsv"></div>

                            </div>
                        </div>

                    </div>
                </div>

                <div cklass="search-container">
                    <div class="amc-search-bar" (click)="toggleShowSearch()">
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.2094 13.7386L12.9178 11.4981L12.8641 11.4164C12.7643 11.317 12.6277 11.261 12.4852 11.261C12.3426 11.261 12.2061 11.317 12.1062 11.4164C10.1587 13.2031 7.15783 13.3002 5.09373 11.6434C3.02964 9.98651 2.54284 7.08981 3.95619 4.87434C5.36953 2.65888 8.24444 1.81213 10.6743 2.89565C13.1041 3.97918 14.3349 6.65676 13.5504 9.15262C13.4939 9.33293 13.5401 9.52901 13.6716 9.66701C13.803 9.805 13.9998 9.86394 14.1878 9.82162C14.3757 9.7793 14.5263 9.64216 14.5828 9.46185C15.5207 6.49999 14.1042 3.3126 11.2498 1.9616C8.39539 0.610603 4.95962 1.50144 3.1651 4.05784C1.37058 6.61423 1.75585 10.069 4.07168 12.1872C6.38752 14.3055 9.93892 14.4515 12.4285 12.5308L14.4575 14.5146C14.6671 14.7186 15.0058 14.7186 15.2154 14.5146C15.4247 14.3077 15.4247 13.9746 15.2154 13.7678L15.2094 13.7386Z"
                                fill="#667085" />
                        </svg>
                        <span>Search</span>
                    </div>
                </div>


            </div>


        </div>
    </div>



    <div class="panel-div">

        <form class="search-form" [formGroup]="form" *ngIf="showSearchForm">

            <div class="row mt-2 g-3">
                <div class="col-md-4">
                    <div class="field">
                        <label class="form-label">Payer ASIN</label>
                        <input type="text" class="form-control" formControlName="payerAsin" />
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="field">
                        <label class="form-label">Payment Status</label>
                        <select class="form-select small-option-font" formControlName="paymentStatus">
                            <option value="">-- Select Payment Status --</option>
                            <option value="PAID">PAID</option>
                            <option value="UNPAID">UNPAID</option>
                            <option value="PENDING">PENDING</option>
                            <option value="INITIALIZED">INITIALIZED</option>
                            <option value="APPROVED">APPROVED</option>
                            <option value="DISAPPROVED">DISAPPROVED</option>
                            <option value="REJECTED">REJECTED</option>
                            <option value="FAILED">FAILED</option>
                        </select>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="field">
                        <label class="form-label">Payment Channel</label>
                        <select class="form-select small-option-font" formControlName="paymentChannel">
                            <option value="">-- Select Payment Channel --</option>
                            <option value="WEB">WEB</option>
                            <option value="MOBILE">MOBILE</option>
                            <option value="BANK">BANK</option>
                            <option value="POS">POS</option>
                        </select>
                    </div>
                </div>


                <div class="col-md-4">
                    <div class="field">
                        <label class="form-label">Payment Reference</label>
                        <input type="text" class="form-control" formControlName="paymentReference" />
                    </div>
                </div>



                <div class="col-md-4">
                    <div class="field">
                        <label class="form-label">Start Date</label>
                        <input type="date" class="form-control" formControlName="from" />
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="field">
                        <label class="form-label">End Date</label>
                        <input type="date" class="form-control" formControlName="to" />
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="field">
                        <label class="form-label">Revenue Item</label>
                        <input type="text" class="form-control" formControlName="revenueItem" />
                    </div>
                </div>


            </div>

            <span class="material-symbols-outlined text-danger" style="position: absolute; top: 5px; right: 10px;"
                role="button" (click)="toggleShowSearch()">close</span>


            <div class="actions d-flex align-items-end">
                <span class="clear-all-btn" role="button" (click)="clearSearchFilters()">Clear all filters</span>

                <button class="custom-btn-primary search-button ms-auto" [disabled]="form.pristine"
                    (click)="search(); toggleShowSearch()">Search</button>

            </div>
        </form>

        <div class="table-wrapper border-radius-full">
            <table class="role-table amc-table" appAutoDataLabel>
                <thead class="amc-table-heading">
                    <tr>
                        <th>S/N</th>
                        <th>ASIN</th>
                        <th>Taxpayer Name</th>
                        <th>Revenue Item</th>
                        <th>Date</th>
                        <th>Amount</th>
                        <th>Trans. Ref</th>
                        <th>Payment Channel</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of data?.pagedResponse?.data; let i = index">
                        <td>{{ i + (currentPage -1) + 1 }}</td>
                        <td>{{ item?.taxpayerAsin }}</td>
                        <td>{{ item?.taxpayerName || '--' | titlecase}}</td>
                        <td>{{ item?.revenueItem || '--' }}</td>
                        <td>{{ item?.paymentDate}}</td>
                        <td>{{ item?.amount | nairaCurrency}}</td>
                        <td>{{ item?.transactionReference || '--' }}</td>
                        <td>{{ item?.paymentChannel || '--' }}</td>

                        <td data-label="Action">
                            <div class="amc-table-action-wrapper">
                                <span class="material-symbols-outlined action-icon" data-bs-toggle="dropdown">
                                    more_horiz
                                </span>
                                <div class="dropdown-menu amc-table-action-select">
                                    <div class="dropdown-wrapper">
                                        <div class="action-btn" role="button"
                                            (click)="downloadReceipt(item?.id); $event.stopPropagation()">
                                            Download Receipt

                                            <div class="spinner-light" *ngIf="downloadId == item?.id"></div>
                                        </div>
                                        <div class="action-btn" role="button"
                                            (click)="emailReceipt(item?.id); $event.stopPropagation()">
                                            Email Receipt
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>

                        <!-- <td>
                    <div class="amc-table-action-wrapper">
                      <button class="custom-btn-primary"
                        style="height: 20px; font-size: 13px; padding: 12px 15px; border-radius: 4px;"
                        *ngIf="item?.assignStatus == 'UN_ASSIGNED' && item?.soldStatus != 'SOLD'" role="button">
                        Revoke
                      </button>
                    </div>
                  </td> -->
                    </tr>
                </tbody>
            </table>

            <div class="d-flex justify-content-center action-icon p-3">
                @if(isSearching){
                <app-bounce-loader></app-bounce-loader>
                }

                @if(errorFetchingData) {
                <span class="text-danger">
                    Error fetching data
                </span>
                }

                @if(searchedDataNotFound) {
                <span class="text-danger">
                    No records found
                </span>
                }

                <p *ngIf="!data && !(errorFetchingData || isSearching || searchedDataNotFound)">
                    Please perform a search to view data.
                </p>


            </div>



        </div>




    </div>

    <div class="d-flex justify-content-between align-items-center mt-2 flex-wrap">

        <div class="d-flex align-items-center me-4">
            <div>Rows per page: </div>
            <div class="mx-2">
                <select class="form-control px-6 text-center" style="width: auto; min-width: 40px;"
                    [(ngModel)]="selectedLimit" (change)="updateLimit()">
                    <option [value]=5>5</option>
                    <option [value]=10>10</option>
                    <option [value]=20>20</option>
                    <option [value]=30>30</option>
                    <option [value]=40>40</option>
                    <option [value]=50>50</option>

                </select>
            </div>
        </div>


        <div class="pagination-container">
            <ngb-pagination *ngIf="!isSearching && count > 0" [(page)]="currentPage" (pageChange)="callDb($event)"
                [maxSize]="5" [pageSize]="pageSize" [collectionSize]="count" [boundaryLinks]="true"
                [directionLinks]="true" [rotate]="true" class="pagination justify-content-center my-3">
            </ngb-pagination>
        </div>
    </div>
</div>